import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTopSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronTopSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M12.1768 11.2373C12.0791 11.1397 11.9209 11.1397 11.8232 11.2373L8.53033 14.5302C8.23744 14.8231 7.76256 14.8231 7.46967 14.5302C7.17678 14.2373 7.17678 13.7624 7.46967 13.4695L10.7626 10.1766C11.446 9.49321 12.554 9.49321 13.2374 10.1766L16.5303 13.4695C16.8232 13.7624 16.8232 14.2373 16.5303 14.5302C16.2374 14.8231 15.7626 14.8231 15.4697 14.5302L12.1768 11.2373Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTopSmall;
